import React, { ReactNode } from 'react';
export const EmptyTemplate = (_props: { children: ReactNode[] | ReactNode }): JSX.Element => <></>;
